var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{staticClass:"is-fullwidth",attrs:{"type":"is-facebook","icon-left":"facebook"},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.$t('login.social.facebook'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }